var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 289,
    viewBox: "0 0 364 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_297_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338 56.9877C338 38.5945 321.6 24.5323 303.422 27.3391L51.4221 66.2497C36.7945 68.5083 26 81.0974 26 95.8983V232.974C26 251.381 42.4221 265.446 60.6096 262.618L312.61 223.432C327.223 221.159 338 208.577 338 193.788V56.9877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337 56.9877C337 39.2076 321.146 25.6142 303.575 28.3274L51.5746 67.2379C37.4347 69.4213 27 81.5908 27 95.8983V232.974C27 250.767 42.8747 264.364 60.456 261.63L312.456 222.443C326.582 220.247 337 208.084 337 193.788V56.9877Z",
    stroke: "url(#paint0_linear_297_312)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_297_312",
    x: 0,
    y: 0.981201,
    width: 364,
    height: 288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.403922 0 0 0 0 0.333333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_297_312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_297_312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_297_312",
    x1: 406.5,
    y1: 92,
    x2: 13,
    y2: 198.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131946,
    stopColor: "#338D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218856,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394255,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910408,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002D35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.d314d36037813cda3a8786231ae83df7.svg";
export { ForwardRef as ReactComponent };